import React from 'react'
import UsersPage from './management_pages/UsersPage'
import Prices from './management_pages/Prices'

const managementLinks = (t) => [
  {
    value: t('employers'),
    path: 'users',
    page: <UsersPage />,
    disabled: false
  },
  {
    value: t('prices'),
    path: 'prices',
    page: <Prices />,
    disabled: false
  }
  // {
  //   value: 'Settings',
  //   path: 'settings',
  //   page: <>Settings</>,
  //   disabled: true
  // }
]

export default managementLinks
